module.exports = __webpack_public_path__ + "img/DefaultUserPhoto.57a07a63.svg";